









import {Vue, Component, Prop} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {Mall} from 'supporter';
import {Getter} from 'vuex-class';

@Component({
  components: {
    CompSelectBox
  }
})
export default class DelayCount extends Vue{
  @Getter('mall/malls')
  private malls: Mall[]

  @Prop({required: true})
  private searchFormType!: 'CANCEL' | 'EXCHANGE' | 'RETURN';

  @Prop({required: true})
  private isDelayClicked!: boolean

  @Prop({required: true})
  private onSearch: (page:string, searchDelay:boolean) => void

  private delayTitleMap = {
    CANCEL: this.$t('CLAIM_CONTENT_TOP_CANCEL_DELAY'),
    EXCHANGE: this.$t('CLAIM_CONTENT_TOP_EXCHANGE_DELAY'),
    RETURN: this.$t('CLAIM_CONTENT_TOP_RETURN_DELAY')
  }

  private delayedClaimCount = 0

  public async fetchDelayClaims(){
    const mallNos = this.malls.map(mall => mall.mallNo).join(',')
    const {data: delayedClaims} = await this.$api.getClaimsSummaryDelay({
      params: {
        mallNos,
        period: '3',
        unit: 'MONTH'
      }
    })

    const setDelayClaimMap = {
      'CANCEL': () => this.delayedClaimCount = delayedClaims.cancelDelayCount,
      'EXCHANGE': () => this.delayedClaimCount = delayedClaims.exchangeDelayCount,
      'RETURN': () => this.delayedClaimCount = delayedClaims.returnDelayCount,
    }

    setDelayClaimMap[this.searchFormType]();
  }

  created(){
    this.fetchDelayClaims()
  }
}
